import { render, staticRenderFns } from "./extrafield-values.vue?vue&type=template&id=2990d2f2"
import script from "./extrafield-values.vue?vue&type=script&lang=js"
export * from "./extrafield-values.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports